<template>
  <div id="app">
    <a href="#app">
      <div class="scroll-top" title="Scroll to top">
        <i class="bi bi-chevron-bar-up"></i>
      </div>
    </a>
    <router-view />
  </div>
</template>

<script>
// import Home from "./components/ResearchPages/Home.vue";
// import NavHeader from "./components/ResearchPages/NavHeader";

export default {
  name: "App",
  components: {
    // Home,
    // NavHeader
  },
};
</script>

<style>
#app {
  font-family: "Lato", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
}

/* @import url("./assets/Css/Research.css"); */
@import url("./assets/Scss/main.css");
@import url("https://fonts.googleapis.com/css2?family=Lato&display=swap");
@import url("https://cdn.jsdelivr.net/npm/bootstrap-icons@1.8.0/font/bootstrap-icons.css");
</style>
